/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import './style'
import './media'

/*Ui*/

/*Images*/

const ListDoctorAdvantages = props => (
    <div className={c("list-doctor-advantages", props.className)}>
        {props.children}
    </div>
)

const DoctorAdvantageItem = props => (
    <>
        {props.value &&
        <div className={c("doctor-advantage", props.className)}>
            <div className="doctor-advantage__circle">
                <div className="doctor-advantage__number">
                    {props.number}
                </div>
            </div>
            <div className="doctor-advantage__text">
                {props.children}
            </div>
        </div>
        }
    </>
) 

export { DoctorAdvantageItem } 
export default ListDoctorAdvantages